<!-- This will be be rendered dynamically based on servicenear or tobeonline user -->
<ng-container [ngSwitch]="userType" *ngIf="!router.url.includes('driveSignIn')">
    <app-servicenear-navbar *ngSwitchCase="'servicenear'"></app-servicenear-navbar>
    <app-tobeonline-navbar *ngSwitchCase="'tobeonline'"></app-tobeonline-navbar>
</ng-container>